// extracted by mini-css-extract-plugin
module.exports = {"ar-preview__activate-ar-button":"ARPreview_ar-preview__activate-ar-button__gvp6h"};